import {ActionHandlerBase} from "../action-handler-base";
import {AppIdentifiers, IOpenChatActionPayload} from "@sparkware/uc-sdk-core";

export class OpenChatActionHandler extends ActionHandlerBase<IOpenChatActionPayload> {
    async handle(payload: IOpenChatActionPayload): Promise<void> {
        await this.services.messageBroker.channels.navigation.topics.openApp.publish({
            publisher: payload.launchInfo.sourceAppID.toString()
        }, {
            appID: AppIdentifiers.CRChat,
            launchInfo: payload.launchInfo,
            correlationID: payload.correlationID
        });
    }
}